import { dataLayerSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLayerSolid = /*#__PURE__*/createIcon(dataLayerSolid)
export default IconLayerSolid
